/**
 * Учитывает `import.meta.env.BASE_URL` (мини-приложение не в корне домена).
 * Пример: BASE `/app/` + путь `/seed/x.svg` → `/app/seed/x.svg`.
 */
import { getApiBaseUrl, type ApiBaseUrlEnv } from '../api/getApiBaseUrl'

export function appPublicPath(pathFromRoot: string): string {
  const p = pathFromRoot.startsWith('/') ? pathFromRoot : `/${pathFromRoot}`
  const raw =
    typeof import.meta !== 'undefined' && import.meta.env && typeof import.meta.env.BASE_URL === 'string'
      ? import.meta.env.BASE_URL
      : '/'
  const b = raw.replace(/\/$/, '') || ''
  if (!b) return p
  return `${b}${p}`
}

/**
 * Приводит URL фото анкеты к origin текущего мини-приложения.
 * Нужно для MAX WebView: в БД часто остаётся localhost после сида, а приложение открыто по туннелю/домену.
 */
export function resolveProfileMediaUrl(raw: string | null | undefined): string {
  const u = (raw ?? '').trim()
  if (!u) return ''
  if (typeof window === 'undefined') return u

  if (u.startsWith('//')) {
    return `${window.location.protocol}${u}`
  }

  /** Публичные файлы с API (сиды и т.п.) — в MAX тот же базовый URL, что у fetch `/api`. */
  if (u.startsWith('/api/')) {
    const base = getApiBaseUrl(import.meta.env as unknown as ApiBaseUrlEnv, window).replace(/\/$/, '')
    return `${base}${u}`
  }

  if (u.startsWith('/')) {
    return `${window.location.origin}${appPublicPath(u)}`
  }

  let parsed: URL
  try {
    parsed = new URL(u)
  } catch {
    return u
  }

  const h = parsed.hostname
  if (h === 'localhost' || h === '127.0.0.1' || h === '[::1]' || h === '::1') {
    const pathWithQs = `${parsed.pathname}${parsed.search}${parsed.hash}`
    if (parsed.pathname.startsWith('/api/')) {
      const base = getApiBaseUrl(import.meta.env as unknown as ApiBaseUrlEnv, window).replace(/\/$/, '')
      return `${base}${pathWithQs}`
    }
    return `${window.location.origin}${appPublicPath(parsed.pathname)}${parsed.search}${parsed.hash}`
  }

  return u
}
